import { Component } from '@angular/core';

@Component({
  selector: 'app-setup-account-expired',
  templateUrl: './setup-account-expired.component.html',
  styleUrls: ['../../auth.scss', './setup-account-expired.component.scss'],
})
export class SetupAccountExpiredComponent {}
